
























import CInputAutocomplete from '~/components/shared/configurable/form/input/CInputAutocomplete.vue'
import LocationSuggestionService from '~/services/location/autocomplete/LocationSuggestionService'
import { AutocompleteSuggestion } from '~/models/autocomplete'
import ClosestLocationService from '~/services/location/closest/ClosestLocationService'
import { defineComponent, ref, computed, watch } from '~/utils/nuxt3-migration'
import { ciCompass } from '~/icons/source/solid/compass'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { useDeps } from '~/compositions/dependency-container'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useSnackbar } from '~/compositions/snackbar'

export default defineComponent({
  components: {
    CInputAutocomplete
  },
  props: {
    ...facetHandlerComponentProps,
    size: {
      type: String,
      default: undefined
    }
  },
  setup(props) {
    const [locationSuggestionService, closestLocationService] = useDeps(
      LocationSuggestionService,
      ClosestLocationService
    )
    const { changeParams } = useClassifiedSearchFacet()
    const snackbar = useSnackbar()

    const autocompleteInputRef = ref<typeof CInputAutocomplete>()
    const locations = ref(new Map())
    const selectedLocationName = ref<string | null>(
      props.allValues.humanParams?.[0]?.name || null
    )

    watch(
      () => props.allValues.humanParams,
      humanParams => {
        selectedLocationName.value = humanParams?.[0]?.name || null
      }
    )

    const locationsSuggestions = computed(() =>
      [...locations.value.values()].map(location => ({
        id: location.id,
        name: location.name,
        subText: location.area
      }))
    )

    async function onRequestSuggestions(query: string) {
      locations.value = await locationSuggestionService.getLocations(query)
    }

    function onSuggestionSelect(suggestion: AutocompleteSuggestion) {
      changeParams([
        {
          name: props.urlArgNames[0],
          value: suggestion.id
        },
        { name: 'geolocation', value: null }
      ])
    }

    async function onCurrentLocationButtonClick() {
      try {
        const closestLocations = await closestLocationService.getClosestLocationsToCurrent()
        if (!closestLocations.length) {
          return
        }

        const [closestLocation] = closestLocations

        selectedLocationName.value = closestLocation.name
        locations.value = new Map()

        changeParams([
          {
            name: props.urlArgNames[0],
            value: closestLocation.id
          },
          { name: 'geolocation', value: null }
        ])
      } catch (error) {
        snackbar.error((error as Error).message)
      } finally {
        if (autocompleteInputRef.value) {
          autocompleteInputRef.hideDropdown()
        }
      }
    }

    return {
      ciCompass,
      autocompleteInputRef,
      locations,
      selectedLocationName,
      locationsSuggestions,
      onSuggestionSelect,
      onRequestSuggestions,
      onCurrentLocationButtonClick
    }
  }
})
